import Automations from './Automations';

export default Automations;
